import React from 'react';
import PropTypes from 'prop-types';
import { Box, Text, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { DateAndTime, SessionDuration } from '../../';
import { SessionType } from '../../../redux/reducers';

const SessionDetails = ({ session, durationSeconds, status, ...rest }) => {
  const { t } = useTranslation();

  const typeStr =
    session.type === SessionType.TEXT
      ? t('interpreter.form.textInterpretation')
      : t('interpreter.form.signInterpretation');

  return (
    <Box {...rest}>
      <Text fontWeight="bold">{session.title}</Text>
      <Text mt={1}>{typeStr}</Text>
      <Box mt={1}>
        <DateAndTime startTime={session.dateTime} duration={durationSeconds} />
      </Box>
      <Flex flexDir="row" mt={1}>
        <Text mr={1}>{`${t('interpreter.estimatedDuration')} `}</Text>
        <SessionDuration durationSeconds={durationSeconds} />
      </Flex>
      <Text mt={1} whiteSpace="nowrap">
        {`${t('interpreter.creator')} ${session.username}`}
      </Text>
      <Text mt={1} whiteSpace="nowrap">
        {`${t('interpreter.status')}: ${status}`}
      </Text>
    </Box>
  );
};

SessionDetails.propTypes = {
  session: PropTypes.object,
  durationSeconds: PropTypes.any,
  status: PropTypes.string,
};

export default SessionDetails;
